import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../Config";
import SupportTopMenu from "./SupportTopMenu";

function AddTicketType() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Support/SaveTicketType",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        ID: 0,
        TicketType: event.target.ticketType.value.trim(),
        Is_Active: isActive,
      },
    })
      .then((response) => {
        if (response.data.status_code === 1) {
          toast.success(response.data.status_message);
          navigate("/support/ticket-types");
        } else {
          toast.error(response.data.status_message || "Save failed.");
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        toast.error("Network error.");
      });

    setValidated(true);
  };

  return (
    <>
      <ToastContainer />
      <SupportTopMenu />
      <div className="page-head">
        <div className="container">
          <div className="page-title">Add Ticket Type</div>
        </div>
      </div>
      <div className="container">
        <div className="card">
          <div className="card-body p-md-4">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <div className="row gy-3" style={{ maxWidth: "520px" }}>
                <div className="col-12">
                  <label className="form-label">Department / Type name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="ticketType"
                    maxLength={300}
                    required
                  />
                </div>
                <div className="col-12">
                  <Form.Check
                    type="checkbox"
                    id="ticketTypeActive"
                    label="Active"
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)}
                  />
                </div>
                <div className="col-12">
                  <button
                    type="submit"
                    className="button button-primary"
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>
                  <Link
                    to="/support/ticket-types"
                    className="button button-outline-primary ms-2"
                  >
                    Cancel
                  </Link>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddTicketType;
